import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_MEMBERSHIP_GRADES,
    fetchMembershipGradeReceived
} from '../actions'



function * fetchMembershipGrade (paylaod){
    try{
       const response=  yield call(DCore.get, '/membershipclasses')
        yield put (fetchMembershipGradeReceived(response.data))

    }catch(e){
        console.log("some thing went wrong", e)
    }
}



export function * membershipGradeSaga(){
    yield takeLatest(FETCH_MEMBERSHIP_GRADES, fetchMembershipGrade)
}